import {Button}      from "react-bootstrap";
import React         from "react";
import {useUser}     from "../../context/UserProvider/UserProvider";
import {useNavigate} from "react-router-dom";

import icon from '../../assets/icons/noun-account-6748990-005566.svg';

const AuthPanel = () => {
    const {authenticatedUser, onSignUpClick, onSignInClick, signOut} = useUser();
    const navigate = useNavigate();

    function navigateToAccount() {
        navigate('/account');
    }

    return (
        <div className="auth-panel">
            <a href="/about" className="btn btn-link auth-link logInButton">About</a>
            {authenticatedUser ? (
                <a className="btn btn-outline-dark  accountButton" type="button"
                   onClick={signOut}>
                    Sign out
                </a>
                // <a className="btn btn-outline-dark  accountButton" type="button"
                //    onClick={navigateToAccount}>
                //     {icon && <img src={icon} alt="account icon" className="accountIcon"
                // 	              width="23" height="23"/>}Settings
                // </a>


            ) : (
                 <>
                     <button className="btn btn-link logInButton" onClick={onSignInClick}>Log in</button>
                     <Button size="lg" className="btn signUpButton" onClick={onSignUpClick}>
                         Sign&nbsp;up<span className="d-none d-lg-inline">&nbsp;for free</span>
                     </Button>
                 </>
             )}
        </div>
    )
}
export default AuthPanel;